<template>
    <div>
        <div class="BigBox">
            <img src="@/images/logo2.png" style="width: 7.65625vw;height: 7.13542vw;">
            <div class="codeCss">
                <div>
                    官方微信
                </div>
                <img src="@/images/scanCode.png" style="width: 5.57292vw;height: 5.57292vw;">
                <div style="color:#666;font-size: 0.9375vw;">
                    获取更多服务
                </div>
            </div>
            <div class="line"></div>
            <div class="textCss">
                <div style="font-weight: 600;font-size: 1.45833vw;color:#323232">联系我们</div>
                <div style="margin-top: 0.78125vw;">
                    湖南见心科技有限公司<br>
                    前身为湖南图斯心理咨询有限公司<br>
                    地址：湖南省长沙市临空经济区一期5栋1单元心理大楼<br>
                    电话：0731-8620 6056
                </div>
            </div>
        </div>
        <div style="width: 100vw;height: 3.17708vw;text-align: center;line-height: 3.17708vw;background-color: #f0f6fa;font-size: 0.9375vw;cursor: pointer;"
            @click="ToGO">
            Copyright © 2025 见心心理 All Rights Reserved.
        </div>
    </div>
</template>

<script>
export default {
    name: 'bottomComVue',
    data() {
        return {

        }
    },
    methods: {
        ToGO() {
            window.location.href = "https://www.foheart.cn";
        }
    }
}
</script>

<style lang="less" scoped>
.BigBox {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100vw;
    height: 18.48958vw;
}

.codeCss {
    margin-left: 17.8125vw;
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 1.45833vw;
    color: #323232;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 10.05208vw;
    justify-content: space-between;
}

.line {
    width: 0.10417vw;
    height: 9.97vw;
    background: #D1D1D1;
    margin-left: 3.8125vw;
    margin-right: 3.8125vw;
}

.textCss {
    font-family: SourceHanSansCN, SourceHanSansCN;
    font-weight: 500;
    font-size: 1.04167vw;
    color: #666666;
    // line-height: 1.875vw;
    height: 10.05208vw;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
}
</style>